import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnalysis = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 28H30V30H10V28Z",
			fill: "#00a4ec"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 30L10 10L12 10L12 30H10Z",
			fill: "#00a4ec"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.6036 16.581C16.1237 18.8605 16 21.5335 16 23H14C14 21.4665 14.1263 18.6395 14.6465 16.169C14.9047 14.9423 15.2756 13.7248 15.8256 12.7899C16.3692 11.8657 17.2288 11 18.5 11C19.7842 11 20.5562 11.8488 20.9998 12.7168C21.4304 13.5593 21.6701 14.6263 21.8556 15.5539C21.8978 15.765 21.9373 15.969 21.9753 16.1652C22.1168 16.8956 22.2376 17.5191 22.4018 18.0119C22.484 18.2585 22.5576 18.4073 22.611 18.4898C22.7214 18.4676 22.8231 18.406 22.9469 18.2727C23.1423 18.0622 23.3214 17.7462 23.5431 17.3028C23.5699 17.2492 23.5979 17.1924 23.6271 17.1332C23.8072 16.7678 24.0318 16.3124 24.297 15.953C24.6216 15.5132 25.1636 15 26 15C26.5344 15 26.9532 15.2668 27.2369 15.528C27.5248 15.793 27.7655 16.1341 27.9677 16.4847C28.3745 17.1898 28.729 18.1166 29.0203 19.0877C29.6028 21.0291 30 23.3782 30 25H28C28 23.6218 27.6472 21.4709 27.1047 19.6623C26.8335 18.7584 26.5317 17.9977 26.2354 17.4841C26.1261 17.2946 26.0311 17.1629 25.9562 17.0766C25.9414 17.0944 25.9247 17.1156 25.9061 17.1407C25.7555 17.3449 25.6218 17.6141 25.433 17.9942C25.401 18.0586 25.3674 18.1262 25.3319 18.1972C25.1161 18.6288 24.8264 19.1878 24.4125 19.6336C23.9669 20.1134 23.3419 20.5 22.5 20.5C21.8833 20.5 21.418 20.1911 21.1069 19.8158C20.8201 19.4696 20.6361 19.0392 20.5044 18.6444C20.2944 18.0142 20.1405 17.2161 19.9967 16.4703C19.9622 16.2915 19.9284 16.1158 19.8944 15.9461C19.7049 14.9987 19.5071 14.1907 19.2189 13.627C18.9438 13.0887 18.7158 13 18.5 13C18.2712 13 17.9433 13.1343 17.5494 13.8039C17.1619 14.4627 16.8453 15.4327 16.6036 16.581ZM26.0504 16.9874C26.0503 16.9882 26.046 16.9913 26.0377 16.9942C26.0463 16.988 26.0505 16.9866 26.0504 16.9874Z",
			fill: "#00a4ec"
		})
	]
});
export default SvgAnalysis;
